





import { defineComponent } from '@vue/composition-api';

import PanelWithAgendaEditor from '@/components/Live/PanelWithAgendaEditor.vue';

const New = defineComponent({
  components: {
    PanelWithAgendaEditor,
  },
  // setup() {},
});

export default New;
